/**
 * Подписка на топик как React-хук.
 *
 * Отдельно от useQuery намеренно: тот спрашивает и забывает, а здесь снимок
 * живёт и меняется. Смешать их значило бы прятать за одним именем два разных
 * поведения — и однажды удивиться, почему экран не обновляется сам.
 */
import { useEffect, useState } from 'react';
import { subscribe } from './socket.ts';
import { useConnection } from './hooks.ts';

/**
 * Слушает топик и отдаёт последнее событие.
 *
 * Порядковый номер приходит вместе с событием: если он прыгнул больше чем на
 * единицу, часть событий потерялась при обрыве. Для хода прохода это неважно
 * — следующее сообщение всё равно перекроет предыдущее, — но знать об этом
 * должен вызывающий, а не догадываться.
 */
export function useTopic<T>(topic: string): { last: T | null; seq: number; gap: boolean } {
  const { status } = useConnection();
  const [state, setState] = useState<{ last: T | null; seq: number; gap: boolean }>({
    last: null, seq: 0, gap: false,
  });

  useEffect(() => {
    if (status !== 'ready') return;
    return subscribe(topic, (seq, data) => {
      setState((prev) => ({
        last: data as T,
        seq,
        gap: prev.seq > 0 && seq > prev.seq + 1,
      }));
    });
  }, [topic, status]);

  return state;
}
